<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';

export default {
    name: "StateMixin",

    computed: {

        ...mapGetters({
            GET_BY_KEY: 'GET_BY_KEY',
            GET_STATE:  'GET_STATE',
            GET_PUBLICATION_TYPE:  'getPublicationType',
        }),

    },

    methods: {

        ...mapMutations({
            CREATE_STATE_BY_KEY: 'CREATE_STATE_BY_KEY',
            SET_PET_BY_KEY:      'SET_PET_BY_KEY',
            SET_PET_ARRAY_INDEX: 'SET_PET_ARRAY_INDEX',
            SET_STATE_BY_MODEL:  'SET_STATE_BY_MODEL',
            SET_BY_KEY:          'SET_BY_KEY',
            SET_ARRAY_INDEX:     'SET_ARRAY_INDEX',
            SET_PUBLICATION_TYPE:'setPublicationType',
        }),

        ...mapActions({
            ACTION_STORE:    'ACTION_STORE',
        }),

    }

}

</script>
